import { useSearchParams } from "react-router-dom";
import { AppFile } from "../../../models";
import { useEffect, useState } from "react";
import AppFileService from "../../../services/AppFileService";
import Breadcrumbs from "../../../components/breadcrumbs";
import AppFilesTable from "./ui/AppFilesTable";
import AppFilesSkeleton from "./skeletons/AppFilesSkeleton";
import { CreateFile } from "./ui/buttons";
export default function AppFilesPage() {
  const [searchParams] = useSearchParams();
  const api = new AppFileService();
  const [files, setFiles] = useState<AppFile[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [searchParams.get("reload")]);

  const fetchData = async () => {
    const data = await api.getAppFiles();
    setFiles(data);
    setLoading(false);
  };

  return (
    <div className="w-full">
         <Breadcrumbs
                    breadcrumbs={[
                      { label: "App Files", href: "/admin/app-files" },                      
                    ]}
                  />
      
      <CreateFile />
      {loading ? (
        <AppFilesSkeleton />
      ) : (
        <AppFilesTable files={files} />
      )}
    </div>
  );
}
